import { atom } from 'jotai';
import User from '../service/types/User';

export const teamLeadersAtom = atom<User[]>([]);
